export const STUDENTS_RESULTS = "STUDENTS_RESULTS";
